import PropTypes from 'prop-types';
import React from 'react';

import { useUser } from '@sophocles/app';
import ToastComponent from '@sophocles/providers/ToastComponent';
import UserActionBlockersContainer from '@sophocles/views/auth/dialogs/UserActionBlockersContainer';

// Tenant colors are now consumed by TenantThemeProvider (see
// `src/theme/TenantThemeProvider.jsx`), which reads tenantInfo from
// the same Redux slice and writes the brand CSS vars itself.  No
// per-component setSwatches call needed.
function App({ children }) {
  const { user } = useUser();
  return (
    <div>
      <ToastComponent />
      {React.Children.map(children, child => React.cloneElement(child))}
      {!!user.get('id', false) && <UserActionBlockersContainer user={user} />}
    </div>
  );
}

App.propTypes = {
  children: PropTypes.element,
};

export default App;
